<!--page-title [title]="'Auto Predict Used'"></page-title-->
<!-- <search-vehicle [routeName]="'/vehicle-list-used'"></search-vehicle> -->
<app-bi-search-vehicle [routeName]="'/vehicle-list-used'"></app-bi-search-vehicle>
<!--no-record-found [notFoundHeading]="'No record found for Autopredict New'" [notFoundDescription]="'Please try again later'"></no-record-found-->
